export default {
  component: () => import("@/modules/profesor/layouts/ProfesorLayout"),
  children: [
    {
      path: "/profesor/grupos",
      name: "profesor-grupos",
      component: () => import("@/modules/profesor/views/GruposView.vue"),
    },
  ],
};
